import { render, staticRenderFns } from "./prepaid-records.vue?vue&type=template&id=02b75b56"
import script from "./prepaid-records.vue?vue&type=script&lang=js"
export * from "./prepaid-records.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports